import { Recipe } from '$tablet-app/src/app/recipes/types';
import { CalendarItemType } from '@akin-home/amplify';
import { useGetCalendarItem } from '@akin-home/calendar/combined';
import React from 'react';
import { StyleSheet } from 'react-native';
import ChatWidget from '../../chat/ChatItem/ChatWidget';
import ChatWidgetHeader from '../../chat/ChatItem/ChatWidgetHeader';
import { useRootStackNavigation } from '../../navigation/hooks';
import { margin, palette } from '../../theme';
import { CalendarItemDetailWidget } from '../CalendarItemDetail/CalendarItemDetailWidget';

interface Props {
  item_id: string;
  type: CalendarItemType;
  recurrence_id?: string;
}

/**
 * Display a single calendar item as it should appear in a list view.
 */
const CalendarListItemChatView = (props: Props) => {
  const { item_id: id, type, recurrence_id } = props;

  const { navigate } = useRootStackNavigation();

  const { item } = useGetCalendarItem({
    id,
    recurrence_id,
    type,
  });

  const onPressRecipe = (recipe: Recipe) =>
    navigate('RecipeDetails', { recipe_id: recipe.id });

  return item ? (
    <ChatWidget
      header={<ChatWidgetHeader header_text="CALENDAR" icon={'calendar-day'} />}
    >
      <CalendarItemDetailWidget
        style={styles.auto_height}
        item={item}
        onChecklistPress={() => undefined}
        onPressRecipe={onPressRecipe}
      />
    </ChatWidget>
  ) : null;
};

const styles = StyleSheet.create({
  container: {
    ...margin(10),
    backgroundColor: palette.white,
  },
  auto_height: {
    height: 'auto',
  },
});

export default CalendarListItemChatView;
